import { render, staticRenderFns } from "./MBPDepartmentsTable.vue?vue&type=template&id=5ed6ad7c"
import script from "./MBPDepartmentsTable.vue?vue&type=script&lang=js"
export * from "./MBPDepartmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports